import React from "react";
import {
  Smartphone,
  TabletSmartphone,
  Headphones,
  Plug,
  BatteryCharging,
  Watch,
  Laptop,
  Monitor,
  Keyboard,
  HardDrive,
  Usb,
  Cpu,
  Tv,
  Speaker,
  Projector,
  Mic,
  Camera,
  Film,
  Gamepad2,
  Disc,
  Router,
  Lightbulb,
  Radio,
  Car,
  Gauge,
  Video,
  Fan,
  Flame,
  WashingMachine,
  Snowflake,
  Coffee,
  Utensils,
  Cable,
  Wrench,
  Battery,
  ShieldCheck,
} from "lucide-react";

export interface CategoryItem {
  id: number;
  name: string;
  icon: React.ComponentType<{ size?: number; color?: string }>;
  parentId?: number | null;
  color?: string;
}


/* ──────────────────────────────────────────────
   1️⃣ TOP LEVEL ELECTRONICS CATEGORIES (FIXED IDS)
   ────────────────────────────────────────────── */
export const electronicsCategories: CategoryItem[] = [
  { id: 20000001, name: "Phones",                 icon: Smartphone,      color: "#1976D2" },
  { id: 20000020, name: "Tablets",                icon: TabletSmartphone,color: "#1565C0" },
  { id: 20000002, name: "Computers",              icon: Monitor,         color: "#7B1FA2" },
  { id: 20000021, name: "Laptops",                icon: Laptop,          color: "#6A1B9A" },
  { id: 20000003, name: "TVs",                    icon: Tv,              color: "#E64A19" },
  { id: 20000022, name: "Home Entertainment",     icon: Speaker,         color: "#BF360C" },
  { id: 20000004, name: "Audio",                  icon: Headphones,      color: "#009688" },
  { id: 20000005, name: "Cameras",                icon: Camera,          color: "#455A64" },
  { id: 20000023, name: "Fiml & Photography",            icon: Film,            color: "#37474F" },
  { id: 20000006, name: "Gaming",                 icon: Gamepad2,        color: "#0288D1" },
  { id: 20000007, name: "Home Appliances",        icon: WashingMachine,  color: "#4CAF50" },
  { id: 20000008, name: "Kitchen Electronics",    icon: Utensils,        color: "#8E44AD" },
  { id: 20000009, name: "Networking",             icon: Router,          color: "#43A047" },
  { id: 20000024, name: "Smart Home",             icon: Lightbulb,       color: "#2E7D32" },
  { id: 20000010, name: "Car Electronics",        icon: Car,             color: "#616161" },
  { id: 20000011, name: "Tools",                  icon: Wrench,          color: "#FBC02D" },
  { id: 20000025, name: "Accessories",            icon: Cable,           color: "#F9A825" },
  { id: 20000012, name: "Office Electronics",     icon: Monitor,         color: "#5C6BC0" },
  { id: 20000014, name: "Security",               icon: ShieldCheck,     color: "#C62828" },
  { id: 20000027, name: "Surveillance",           icon: Camera,          color: "#B71C1C" },
  { id: 20000015, name: "Wearables",              icon: Watch,           color: "#AD1457" },
  { id: 20000016, name: "GPS",                    icon: Gauge,           color: "#546E7A" },
  { id: 20000028, name: "Navigation",             icon: Gauge,           color: "#455A64" },
  { id: 20000017, name: "eBook Readers",          icon: TabletSmartphone,color: "#6D4C41" },
];



/* ──────────────────────────────────────────────
   2️⃣ SUBCATEGORIES FOR EACH TOP LEVEL (FIXED IDS)
   ────────────────────────────────────────────── */
export const electronicsSubcategories: CategoryItem[] = [
  /* -----------------------------
      1️⃣ PHONES & TABLETS
  ------------------------------*/
  { id: 20000101, parentId: 20000001, name: "Smartphones", icon: Smartphone },
  { id: 20000102, parentId: 20000001, name: "Feature Phones", icon: Smartphone },
  { id: 20000103, parentId: 20000001, name: "Tablets", icon: TabletSmartphone },
  { id: 20000104, parentId: 20000001, name: "Phone Cases", icon: Cable },
  { id: 20000105, parentId: 20000001, name: "Screen Protectors", icon: Cable },
  { id: 20000106, parentId: 20000001, name: "Chargers & Cables", icon: Plug },
  { id: 20000107, parentId: 20000001, name: "Power Banks", icon: BatteryCharging },
  { id: 20000108, parentId: 20000001, name: "Earphones / Bluetooth Earbuds", icon: Headphones },
  { id: 20000109, parentId: 20000001, name: "Smartwatches / Fitness Bands", icon: Watch },

  /* -----------------------------
      2️⃣ COMPUTERS & LAPTOPS
  ------------------------------*/
  { id: 20000201, parentId: 20000002, name: "Laptops", icon: Laptop },
  { id: 20000202, parentId: 20000002, name: "Desktops", icon: Monitor },
  { id: 20000203, parentId: 20000002, name: "Monitors", icon: Monitor },
  { id: 20000204, parentId: 20000002, name: "Keyboards & Mice", icon: Keyboard },
  { id: 20000205, parentId: 20000002, name: "Laptop Bags & Stands", icon: HardDrive },
  { id: 20000206, parentId: 20000002, name: "External HDD / SSD", icon: HardDrive },
  { id: 20000207, parentId: 20000002, name: "Flash Disks", icon: Usb },
  { id: 20000208, parentId: 20000002, name: "Computer Components", icon: Cpu },

  /* -----------------------------
      3️⃣ TVS & HOME ENTERTAINMENT
  ------------------------------*/
  { id: 20000301, parentId: 20000003, name: "Smart TVs", icon: Tv },
  { id: 20000302, parentId: 20000003, name: "TV Boxes (Android Box)", icon: Tv },
  { id: 20000303, parentId: 20000003, name: "Home Theatre Systems", icon: Speaker },
  { id: 20000304, parentId: 20000003, name: "Soundbars", icon: Speaker },
  { id: 20000305, parentId: 20000003, name: "Projectors", icon: Projector },
  { id: 20000306, parentId: 20000003, name: "HDMI Cables / TV Mounts", icon: Cable },

  /* -----------------------------
      4️⃣ AUDIO
  ------------------------------*/
  { id: 20000401, parentId: 20000004, name: "Bluetooth Speakers", icon: Speaker },
  { id: 20000402, parentId: 20000004, name: "Home Audio Systems", icon: Radio },
  { id: 20000403, parentId: 20000004, name: "Headphones", icon: Headphones },
  { id: 20000404, parentId: 20000004, name: "Studio Microphones", icon: Mic },
  { id: 20000405, parentId: 20000004, name: "Podcast Equipment", icon: Mic },

  /* -----------------------------
      5️⃣ CAMERAS & PHOTOGRAPHY
  ------------------------------*/
  { id: 20000501, parentId: 20000005, name: "DSLR / Mirrorless Cameras", icon: Camera },
  { id: 20000502, parentId: 20000005, name: "Action Cameras (GoPro Style)", icon: Film },
  { id: 20000503, parentId: 20000005, name: "Camera Lenses", icon: Camera },
  { id: 20000504, parentId: 20000005, name: "Tripods", icon: Gauge },
  { id: 20000505, parentId: 20000005, name: "Lighting & Soft Boxes", icon: Lightbulb },
  { id: 20000506, parentId: 20000005, name: "Memory Cards", icon: Usb },

  /* -----------------------------
      6️⃣ GAMING
  ------------------------------*/
  { id: 20000601, parentId: 20000006, name: "PlayStation / Xbox Consoles", icon: Gamepad2 },
  { id: 20000602, parentId: 20000006, name: "Gaming Accessories", icon: Gamepad2 },
  { id: 20000603, parentId: 20000006, name: "Gaming Keyboards & Mice", icon: Keyboard },
  { id: 20000604, parentId: 20000006, name: "VR Devices", icon: Disc },
  { id: 20000605, parentId: 20000006, name: "Nintendo Switch", icon: Disc },

  /* -----------------------------
      7️⃣ HOME APPLIANCES
  ------------------------------*/
  { id: 20000701, parentId: 20000007, name: "Fridges", icon: Snowflake },
  { id: 20000702, parentId: 20000007, name: "Microwaves", icon: Flame },
  { id: 20000703, parentId: 20000007, name: "Cookers", icon: Flame },
  { id: 20000704, parentId: 20000007, name: "Washing Machines", icon: WashingMachine },
  { id: 20000705, parentId: 20000007, name: "Vacuum Cleaners", icon: Fan },
  { id: 20000706, parentId: 20000007, name: "Fans & Heaters", icon: Fan },

  /* -----------------------------
      8️⃣ KITCHEN ELECTRONICS
  ------------------------------*/
  { id: 20000801, parentId: 20000008, name: "Blenders", icon: Utensils },
  { id: 20000802, parentId: 20000008, name: "Electric Kettles", icon: Coffee },
  { id: 20000803, parentId: 20000008, name: "Air Fryers", icon: Flame },
  { id: 20000804, parentId: 20000008, name: "Coffee Machines", icon: Coffee },
  { id: 20000805, parentId: 20000008, name: "Toasters", icon: Flame },

  /* -----------------------------
      9️⃣ NETWORKING & SMART HOME
  ------------------------------*/
  { id: 20000901, parentId: 20000009, name: "WiFi Routers", icon: Router },
  { id: 20000902, parentId: 20000009, name: "CCTV Cameras", icon: Video },
  { id: 20000903, parentId: 20000009, name: "Smart Bulbs", icon: Lightbulb },
  { id: 20000904, parentId: 20000009, name: "Smart Plugs", icon: Plug },
  { id: 20000905, parentId: 20000009, name: "Doorbells", icon: Radio },
  { id: 20000906, parentId: 20000009, name: "GPS Trackers", icon: Gauge },

  /* -----------------------------
      🔟 CAR ELECTRONICS
  ------------------------------*/
  { id: 20001001, parentId: 20000010, name: "Car Stereos", icon: Car },
  { id: 20001002, parentId: 20000010, name: "Reverse Cameras", icon: Video },
  { id: 20001003, parentId: 20000010, name: "Dashcams", icon: Video },
  { id: 20001004, parentId: 20000010, name: "Car Chargers", icon: BatteryCharging },
  { id: 20001005, parentId: 20000010, name: "Car Tracking Devices", icon: Gauge },

  /* -----------------------------
      1️⃣1️⃣ TOOLS & ACCESSORIES
  ------------------------------*/
  { id: 20001101, parentId: 20000011, name: "Extension Cables", icon: Cable },
  { id: 20001102, parentId: 20000011, name: "UPS", icon: Battery },
  { id: 20001103, parentId: 20000011, name: "Stabilizers", icon: BatteryCharging },
  { id: 20001104, parentId: 20000011, name: "Batteries", icon: Battery },
  { id: 20001105, parentId: 20000011, name: "Surge Protectors", icon: Plug },
];


/* ──────────────────────────────────────────────
   3️⃣ PRODUCT VARIANTS (electronicsProducts)
   parentId = subcategoryId
   ────────────────────────────────────────────── */
export const electronicsProducts: CategoryItem[] = [
  /* -------- PHONES & TABLETS -------- */
  { id: 20010101, parentId: 20000101, name: "iPhone", icon: Smartphone },
  { id: 20010102, parentId: 20000101, name: "Samsung Galaxy", icon: Smartphone },
  { id: 20010103, parentId: 20000101, name: "Xiaomi Redmi", icon: Smartphone },
  { id: 20010301, parentId: 20000103, name: "iPad", icon: TabletSmartphone },
  { id: 20010302, parentId: 20000103, name: "Samsung Tablet", icon: TabletSmartphone },
  { id: 20010701, parentId: 20000107, name: "20,000mAh Powerbank", icon: BatteryCharging },
  { id: 20010801, parentId: 20000108, name: "Bluetooth Earbuds", icon: Headphones },
  { id: 20010901, parentId: 20000109, name: "Smartwatch", icon: Watch },

  /* -------- COMPUTERS & LAPTOPS -------- */
  { id: 20020101, parentId: 20000201, name: "MacBook Pro", icon: Laptop },
  { id: 20020102, parentId: 20000201, name: "HP Laptop", icon: Laptop },
  { id: 20020201, parentId: 20000202, name: "Gaming PC", icon: Cpu },
  { id: 20020301, parentId: 20000203, name: "24” Monitor", icon: Monitor },
  { id: 20020601, parentId: 20000206, name: "External SSD", icon: HardDrive },
  { id: 20020701, parentId: 20000207, name: "USB Flash Drive 64GB", icon: Usb },

  /* -------- TV & HOME ENTERTAINMENT -------- */
 { id: 20030101, parentId: 20000301, name: "25” Smart TV", icon: Tv },
{ id: 20030102, parentId: 20000301, name: "32” Smart TV", icon: Tv },
{ id: 20030103, parentId: 20000301, name: "40” Smart TV", icon: Tv },
{ id: 20030104, parentId: 20000301, name: "43” Smart TV", icon: Tv },
{ id: 20030105, parentId: 20000301, name: "50” Smart TV", icon: Tv },
{ id: 20030106, parentId: 20000301, name: "55” Smart TV", icon: Tv },
{ id: 20030107, parentId: 20000301, name: "60” Smart TV", icon: Tv },
{ id: 20030108, parentId: 20000301, name: "65” Smart TV", icon: Tv },
{ id: 20030109, parentId: 20000301, name: "70” Smart TV", icon: Tv },
{ id: 20030110, parentId: 20000301, name: "75” Smart TV", icon: Tv },
{ id: 20030111, parentId: 20000301, name: "85” Smart TV", icon: Tv },
{ id: 20030112, parentId: 20000301, name: "98” Smart TV", icon: Tv },
{ id: 20030113, parentId: 20000301, name: "100” Smart TV", icon: Tv },
  { id: 20030201, parentId: 20000302, name: "Android TV Box", icon: Tv },
  { id: 20030401, parentId: 20000304, name: "Soundbar", icon: Speaker },

  /* -------- AUDIO -------- */
  { id: 20040101, parentId: 20000401, name: "Portable Bluetooth Speaker", icon: Speaker },
  { id: 20040301, parentId: 20000403, name: "Wireless Headphones", icon: Headphones },
  { id: 20040401, parentId: 20000404, name: "Studio Microphone", icon: Mic },

  /* -------- CAMERAS -------- */
  { id: 20050101, parentId: 20000501, name: "Canon DSLR", icon: Camera },
  { id: 20050201, parentId: 20000502, name: "GoPro Hero", icon: Film },
  { id: 20050301, parentId: 20000503, name: "50mm Lens", icon: Camera },

  /* -------- GAMING -------- */
  { id: 20060101, parentId: 20000601, name: "PlayStation 5", icon: Gamepad2 },
  { id: 20060201, parentId: 20000602, name: "Gaming Controller", icon: Gamepad2 },
  { id: 20060501, parentId: 20000605, name: "Nintendo Switch", icon: Disc },

  /* -------- HOME APPLIANCES -------- */
  { id: 20070101, parentId: 20000701, name: "Double Door Fridge", icon: Snowflake },
  { id: 20070401, parentId: 20000704, name: "Washing Machine 7KG", icon: WashingMachine },

  /* -------- KITCHEN ELECTRONICS -------- */
  { id: 20080101, parentId: 20000801, name: "Blender 2L", icon: Utensils },
  { id: 20080201, parentId: 20000802, name: "Electric Kettle", icon: Coffee },
  { id: 20080301, parentId: 20000803, name: "Air Fryer 6L", icon: Flame },

  /* -------- SMART HOME -------- */
  { id: 20090101, parentId: 20000901, name: "WiFi Router Dual Band", icon: Router },
  { id: 20090201, parentId: 20000902, name: "CCTV Camera", icon: Video },
  { id: 20090301, parentId: 20000903, name: "Smart LED Bulb", icon: Lightbulb },

  /* -------- CAR ELECTRONICS -------- */
  { id: 20100101, parentId: 20001001, name: "Car Stereo", icon: Car },
  { id: 20100201, parentId: 20001002, name: "Reverse Camera", icon: Video },

  /* -------- TOOLS & ACCESSORIES -------- */
  { id: 20110101, parentId: 20001101, name: "Extension Cable 10m", icon: Cable },
  { id: 20110401, parentId: 20001104, name: "AA Batteries (Pack)", icon: Battery },
];
